export const taskJson={
    Invoice_Id:0,
    Task_Title:"",
    Task_Description:"",
    Assigned_to:0,
    Due_Date:"",
    Due_Time:"",
    Task_Type:0,
    Priority:0
}